import React, { useEffect } from "react";
import { useLocation } from "react-use";

import useUpdateMailStatus from "../hooks/useUpdateMailStatus";
import dayjs from "dayjs";
import SingleMail from "../components/SingleMail";

const Inboxmails = ({
  date,
  setSelectedEmail,
  fechedMails,
  inboxMails,
  selectedEmail,
  searchedMails,
  searchTerm,
  isUpdated,
  setIsUpdated,
}) => {
  const location = useLocation();
  const useupdateMailStatus = useUpdateMailStatus();
  let mails;
  if (searchTerm) {
    mails = searchedMails;
  } else if (location.pathname === "/app/mail/inbox") {
    mails = inboxMails;
  } else {
    mails = fechedMails;
  }
  console.log(mails, "mails");
  useEffect(() => {
    setSelectedEmail(null);
  }, [isUpdated, setSelectedEmail]);
  const today = dayjs(new Date()).format("YYYY-MM-DD");
  const filterDate = dayjs(date).format("YYYY-MM-DD");
  const todayMails = (mails || []).filter(
    (mail) => dayjs(mail?.created_time).format("YYYY-MM-DD") === today
  );

  const thisMonthmails = (mails || []).filter(
    (mail) => dayjs(mail?.created_time).format("YYYY-MM-DD") !== today
  );

  return (
    <div className="">
      {today === filterDate ? (
        <div>
          {todayMails?.map((each) => (
            <SingleMail
              each={each}
              selectedEmail={selectedEmail}
              setSelectedEmail={setSelectedEmail}
              useupdateMailStatus={useupdateMailStatus}
              setIsUpdated={setIsUpdated}
              searchTerm={searchTerm}
              today={true}
            />
          ))}

          <div
            className={`${
              thisMonthmails?.[0]?.id === undefined ? "hidden" : ""
            } `}
          >
            <div>
              <h1 className="text-primary text-xs xl:text-sm font-semibold 2xl:text-sm 3xl:text-lg p-2">
                This Month
              </h1>
            </div>
            <div>
              {thisMonthmails?.map((each) => (
                <SingleMail
                  each={each}
                  selectedEmail={selectedEmail}
                  setSelectedEmail={setSelectedEmail}
                  useupdateMailStatus={useupdateMailStatus}
                  setIsUpdated={setIsUpdated}
                  searchTerm={searchTerm}
                />
              ))}
            </div>
          </div>
        </div>
      ) : (
        mails?.map((each) => (
          <SingleMail
            each={each}
            selectedEmail={selectedEmail}
            setSelectedEmail={setSelectedEmail}
            useupdateMailStatus={useupdateMailStatus}
            setIsUpdated={setIsUpdated}
            searchTerm={searchTerm}
          />
        ))
      )}
    </div>
  );
};

export default Inboxmails;
